import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps, PrismicRichText } from '@prismicio/react';
import { PrismicNextLink } from '@prismicio/next';
import ParticlesBackground from '@/components/ParticlesBackground';
import { ArrowRightIcon } from '@/assets';

/**
 * Props for `HeroHeadlineCta`.
 */
export type HeroHeadlineCtaProps = SliceComponentProps<
  Content.HeroHeadlineCtaSlice,
  { isAnimatedPage?: boolean; hasPageBackgroundAnimation?: boolean }
>;

/**
 * Component for "HeroHeadlineCta" Slices.
 */
const HeroHeadlineCta: FC<HeroHeadlineCtaProps> = ({ slice, context }) => {
  const { headline, supporting_text, primary_cta } = slice.primary;
  const isAnimatedPage = context?.isAnimatedPage;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      style={{
        background: isAnimatedPage
          ? 'transparent'
          : 'linear-gradient(180deg, #0e1010 0%, #0f423a 100%)',
      }}
      className="relative text-white pt-48 pb-24 md:pt-48 md:pb-40 overflow-hidden"
    >
      {slice.variation === 'heroWithParticlesVariation' && (
        <ParticlesBackground />
      )}
      <div className="relative z-10 container mx-auto flex flex-col items-center text-center gap-8">
        <div className="px-4 md:px-32 flex flex-col gap-6">
          <div className="font-bold text-4xl md:text-6xl">
            <PrismicRichText field={headline} />
          </div>
          <div className="text-lg">
            <PrismicRichText field={supporting_text} />
          </div>
          <div className="flex justify-center">
            <PrismicNextLink field={primary_cta} className="secondary-button">
              <ArrowRightIcon className="arrow-icon" />
              {slice.primary?.primary_cta.text
                ? slice.primary?.primary_cta.text
                : 'Learn More'}
            </PrismicNextLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroHeadlineCta;
